<template>
	<v-layout class="d-flex flex-column">
		<v-row dense class="pa-0 ma-0">
			<v-col class="pa-0 ma-0" cols="12">
			<span class="data__title">Machos</span>
			</v-col>
			<v-col class="pa-0 mx-0 mr-1" style="min-width: 70px">
				<span class="data__label__text pt-0">Quantidade</span>
				<v-text-field
						outlined
						dense
						:disabled="!canEdit"
						v-model="crechario[`qtMachosDia${nrDia}`]"
						hide-details
						v-only-int
						background-color="white"
				/>
			</v-col>
			<v-col class="pa-0 ma-0 mr-1" style="min-width: 70px">
				<span class="data__label__text pt-0">Peso</span>
				<v-text-field
						outlined
						dense
						:disabled="!canEdit"
						v-model="crechario[`nrPesoMachosDia${nrDia}`]"
						hide-details
						v-only-number
						background-color="white"
				>
					<template v-slot:append>
						<span class="kilo">Kg</span>
					</template>
				</v-text-field>
			</v-col>
		</v-row>
		<v-row class="pa-0 pt-6 ma-0">
			<v-col class="pa-0 ma-0" cols="12">
			<span class="data__title pt-0">Fêmeas</span>
			</v-col>
			<v-col class="pa-0 mx-0 mr-1" style="min-width: 70px">
				<span class="data__label__text pt-0">Quantidade</span>
				<v-text-field
						outlined
						dense
						:disabled="!canEdit"
						v-model="crechario[`qtFemeasDia${nrDia}`]"
						hide-details
						v-only-int
						background-color="white"
				/>
			</v-col>
			<v-col class="pa-0 ma-0 mr-1" style="min-width: 70px">
				<span class="data__label__text pt-0">Peso</span>
				<v-text-field
						outlined
						dense
						:disabled="!canEdit"
						v-model="crechario[`nrPesoFemeasDia${nrDia}`]"
						hide-details
						v-only-number
						background-color="white"
				>
					<template v-slot:append>
						<span class="kilo">Kg</span>
					</template>
				</v-text-field>
			</v-col>
		</v-row>
	</v-layout>
</template>

<script>
import {MODELS} from "../../resources";

export default {
	name: "editableCard",
	props: {
		crechario: {
			required: true,
			type: Object,
		},
		nrDia: {
			required: true,
			type: Number,
			default: 0,
		},
		canEdit: {
			type: Boolean,
			default: true,
		}
	},
}
</script>

<style scoped lang="scss">
::v-deep .v-text-field__suffix {
  padding-top: 0;
  font-size: 10px;
}

.data__title {
  font: 500 12px/14px Roboto;
  letter-spacing: 0px;
  color: #37565C;
}

.data__text {
  font: normal normal bold 12px/16px Roboto;
  letter-spacing: 0;
  color: #37565C;
}

.data__label__text {
  color: #12303C99;
  font: normal normal normal 12px/16px Roboto;
  letter-spacing: 0;
}

.kilo {
  color: #37565C;
  font: normal 500 normal 14px/21px Roboto;
  margin-top: 2px;
}
</style>
